export default {
  "items.title": "القطع والخدمات",
  "items.subtitle": "إدارة القطع والخدمات المتاحة وأسعارها",
  "items.add": "إضافة قطعة",
  "items.add.title": "إضافة قطعة",
  "items.edit.title": "تعديل القطعة",

  "items.duration.title": "مدة التنفيذ",
  "items.duration.normal": "التنفيذ العادي",
  "items.duration.urgent": "التنفيذ المستعجل",
  "items.duration.unit": "ساعة",
  "items.duration.notSet": "لم تُحدد بعد",
  "items.duration.note": "تسري المدد على جميع الطلبات، وتبدأ من استلام المغسلة للطلب فعليًا.",
  "items.duration.settings": "إعدادات مدة التنفيذ",
  "items.duration.scope": "المدد تخص المغسلة بالكامل وليست لكل قطعة.",

  "items.table.item": "القطعة",
  "items.table.status": "حالة القطعة",
  "items.table.actions": "الإجراءات",

  "items.service.wash_only": "غسيل فقط",
  "items.service.iron_only": "كوي فقط",
  "items.service.wash_iron": "غسيل وكوي",

  "items.price.normal": "عادي",
  "items.price.urgent": "مستعجل",
  "items.price.unavailable": "غير متاح",

  "items.status.active": "مفعلة",
  "items.status.inactive": "معطلة",

  "items.action.edit": "تعديل",
  "items.action.deactivate": "تعطيل",
  "items.action.activate": "تفعيل",
  "items.action.delete": "حذف",

  "items.form.itemData": "بيانات القطعة",
  "items.form.name": "اسم القطعة",
  "items.form.image": "صورة توضيحية",
  "items.form.services": "الخدمات والأسعار",
  "items.form.serviceAvailable": "الخدمة متاحة لهذه القطعة",
  "items.form.normalPrice": "السعر العادي",
  "items.form.urgentPrice": "السعر المستعجل",
  "items.form.serviceNote": "تعطيل الخدمة يخص هذه القطعة فقط ولا يؤثر على بقية القطع.",
  "items.form.save": "حفظ القطعة",
  "items.form.saveEdit": "حفظ التعديلات",
  "items.form.cancel": "إلغاء",

  "items.confirm.deactivate.title": "تعطيل القطعة؟",
  "items.confirm.deactivate.text": "لن تظهر هذه القطعة للعملاء أثناء تعطيلها.",
  "items.confirm.deactivate.confirm": "تعطيل القطعة",
  "items.confirm.delete.title": "حذف القطعة؟",
  "items.confirm.delete.text": "هل تريد حذف هذه القطعة من قائمة القطع؟",
  "items.confirm.delete.confirm": "حذف القطعة",

  "items.toast.added": "تمت إضافة القطعة",
  "items.toast.updated": "تم حفظ التعديلات",
  "items.toast.activated": "تم تفعيل القطعة",
  "items.toast.deactivated": "تم تعطيل القطعة",
  "items.toast.deleted": "تم حذف القطعة",

  "items.empty.title": "لم تُضف قطع بعد",
  "items.empty.text": "أضف القطع التي تقدم المغسلة خدماتها عليها",
  "items.empty.action": "إضافة قطعة",

  "items.error": "تعذّر تحميل القطع",
  "items.errorSave": "تعذّر حفظ القطعة، حاول مرة أخرى.",

  "items.image.choose": "اختيار صورة",
  "items.image.replace": "استبدال الصورة",
  "items.image.remove": "إزالة الصورة",
  "items.image.none": "لم تُضف صورة",
  "items.image.optional": "اختياري",
  "items.image.hint": "الصيغة والحجم حسب إعدادات النظام.",

  "items.required.name": "اسم القطعة مطلوب",
  "items.invalid.price": "أدخل سعرًا رقميًا صحيحًا غير سالب",
  "items.form.errorFix": "يرجى تصحيح الحقول المطلوبة قبل الحفظ.",

  "items.demoNote": "هذه معاينة ببيانات تجريبية."
};